module.exports = __webpack_public_path__ + "bb0228ec9f0c4f5849426b97d1407bf6.gif";